import {
  OrderUpdateActions,
  OrderUpdateActionsEnum,
} from "store/modules/Orders/types.store";

interface ModalProps {
  description: string;
  confirmLabel: string;
  denyLabel: string;
  onConfirm: () => void;
  title: string;
}

export default (type?: OrderUpdateActions): ModalProps => {
  switch (type) {
    case OrderUpdateActionsEnum.ACCEPT:
      return {
        description: "Você deseja aceitar o pedido?",
        confirmLabel: "Aceitar",
        denyLabel: "Sair",
        title: "Aceitar pedido",
        onConfirm: () => {},
      };
    case OrderUpdateActionsEnum.START:
      return {
        description: "Você deseja iniciar o pedido?",
        confirmLabel: "Iniciar",
        denyLabel: "Sair",
        title: "Iniciar pedido",
        onConfirm: () => {},
      };
    case OrderUpdateActionsEnum.FINALIZE:
      return {
        description: "Você deseja finalizar o pedido?",
        confirmLabel: "Finalizar",
        denyLabel: "Sair",
        title: "Finalizar pedido",
        onConfirm: () => {},
      };
    case OrderUpdateActionsEnum.DENY:
      return {
        description: "Você deseja recusar o pedido?",
        confirmLabel: "Recusar",
        denyLabel: "Sair",
        title: "Recusar pedido",
        onConfirm: () => {},
      };
    case OrderUpdateActionsEnum.CANCEL:
      return {
        description: "Você deseja cancelar o pedido?",
        confirmLabel: "Cancelar",
        denyLabel: "Sair",
        title: "Cancelar pedido",
        onConfirm: () => {},
      };

    default:
      return {
        description: "",
        confirmLabel: "",
        denyLabel: "",
        title: "",
        onConfirm: () => {},
      };
  }
};
